var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', {
    attrs: {
      "header": "Perekaman Aju"
    }
  }, [_c('loading', {
    attrs: {
      "active": this.$store.state.barpin.isLoading,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        this.$store.state.barpin.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "p-3 pull-right"
  }, [_c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-aju",
      modifiers: {
        "modal-aju": true
      }
    }],
    staticClass: "btn btn-success"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Aju Baru\n        ")])])])]), _vm._v(" "), _c('modal-aju', {
    ref: "modalAju"
  }), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-bordered table-responsive"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("No. Aju")]), _vm._v(" "), _c('th', [_vm._v("Nama")]), _vm._v(" "), _c('th', [_vm._v("Jenis Ajuan")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.aju), function(data) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(data.NO_AJU))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.NAMA_PENERIMA))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.JNS_AJU == '1' ? 'Barang Pindahan' : 'Kendaraan Bermotor'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.status == null ? '' : data.status.ur_status))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "40"
      }
    }, [_c('router-link', {
      staticClass: "btn btn-primary",
      attrs: {
        "to": ("perekaman/" + (data.NO_AJU))
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]), _vm._v(" "), _c('b-button', {
      directives: [{
        name: "b-modal",
        rawName: "v-b-modal.modal-catatan",
        modifiers: {
          "modal-catatan": true
        }
      }],
      attrs: {
        "variant": "secondary"
      },
      on: {
        "click": function($event) {
          _vm.getCatatan(data.ID_AJU)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-bars"
    })]), _vm._v(" "), (data.KD_STATUS == '100') ? _c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          _vm.removePpftz(data.ID_AJU)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()], 1)])
  }))])]), _vm._v(" "), _c('modal-catatan')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5f2b59e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ppftz/MenuAju.vue
// module id = 340
// module chunks = 0